/* apps/fourcomply-dashboard/src/app/app.component.scss */
.mat-drawer-container {
  min-height: calc(100vh - 60px);
  margin-top: 60px;
  width: 100vw;
}
.mat-drawer-side {
  border: 0px;
  margin-top: 70px;
}
::ng-deep .xng-breadcrumb-root {
  padding-left: 20px;
}
::ng-deep .xng-breadcrumb-root .xng-breadcrumb-item {
  margin-top: 0px;
  font-size: 12px;
}
::ng-deep .xng-breadcrumb-root .xng-breadcrumb-separator {
  margin-top: 0px;
  font-size: 12px;
}
::ng-deep .xng-breadcrumb-root .xng-breadcrumb-separator:nth-child(2) {
  display: none;
}
::ng-deep .xng-breadcrumb-root .xng-breadcrumb-link:hover {
  text-decoration: none;
  color: var(--primary-color);
}
.custom-sidenav-class {
  z-index: 960 !important;
}
/*# sourceMappingURL=app.component.css.map */
